<ng-container *ngIf="isLoading">
  <div class="container skeleton">
    <app-skeleton class="page-header" [type]="'text'" [symbolsCount]="18" [additionalElementClasses]="['title']"/>

    <div class="row mb-2">
      <div class="col-1">
        <app-skeleton [height]="450"></app-skeleton>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-1">
        <app-skeleton [height]="200"></app-skeleton>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-1">
        <app-skeleton [height]="150"></app-skeleton>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-1">
        <app-skeleton [height]="300"></app-skeleton>
      </div>
    </div>
  </div>
</ng-container>


<div *ngIf="!isLoading" #pageDataContainer>
  <app-card-header class="container" [title]="pageData.pageTitle" [outside]="true">
  </app-card-header>
  <div *ngIf="pageData.documentTypeAlias">
    <ng-container [ngSwitch]="pageData.documentTypeAlias">
      <app-department-info-page *ngSwitchCase="DocumentPageType.PortalDepartmentInfo" [pageTitle]="pageData.pageTitle" [pageNodeId]="pageData.pageNodeId"></app-department-info-page>
      <app-catalog-page *ngSwitchCase="DocumentPageType.PortalCatalogPage"></app-catalog-page>
      <app-career-lobby-page *ngSwitchCase="DocumentPageType.PortalCareerLobby"></app-career-lobby-page>
      <app-articles-and-news-page *ngSwitchCase="DocumentPageType.PortalArticlesPage"></app-articles-and-news-page>
      <app-portal-messages-page *ngSwitchCase="DocumentPageType.PortalMessagesPage" [pageData]="pageData"></app-portal-messages-page>
      <app-events-lobby-page *ngSwitchCase="DocumentPageType.PortalEventsPage"></app-events-lobby-page>
    </ng-container>
  </div>
  <div class="container">
    <ng-container *ngFor="let row of groupedBlocks">
      <div class="row mb-2">
        <ng-container *ngFor="let block of row">
          <div class="col-{{isMobile ? 1 : block.angularBlockListData?.partOfRow }}" [attr.blocklist-id]="block.id" [ngClass]="getCombinationClasses(block)">
            <ng-container [ngSwitch]="block.blockListType">
              <div *ngSwitchCase="blockListType.ContentBlockList">
                <!-- Handle ContentBlockList type -->
                <div *ngIf="block.html" [innerHTML]="block.html | safeHtml"></div>
              </div>
              
              <div [ngSwitch]="block.angularBlockListType">
                <ng-container *ngSwitchCase="angularBlockListType.StudentCoursesAndTimeTableCalendarBlockList">
                  <app-student-courses-and-time-table-calendar-block-list></app-student-courses-and-time-table-calendar-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.ExamsAndTasksCalendarBlockList">
                  <app-exams-and-tasks-calendar-block-list [pageData]="getPageData(angularBlockListType.ExamsAndTasksCalendarBlockList)"></app-exams-and-tasks-calendar-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentExamsAndTasksListViewBlockList">
                  <app-exams-and-tasks-list-view-block-list [pageData]="getPageData(angularBlockListType.StudentExamsAndTasksListViewBlockList)"></app-exams-and-tasks-list-view-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentAllGradesDetailedListViewBlockList">
                  <app-student-all-grades-detailed-list-view-block-list [data]="block.angularBlockListData" [generalSettingsData]="generalSettingsData"></app-student-all-grades-detailed-list-view-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentRecentInformationListViewBlockList">
                  <app-student-recent-information-list-view-block-list [data]="block.angularBlockListData"></app-student-recent-information-list-view-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentGradesSummaryBlockList">
                  <app-student-grades-summary-block-list [data]="block.angularBlockListData"></app-student-grades-summary-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalVideoWithDescriptionBlockList">
                  <app-portal-video-with-description [data]="block.angularBlockListData"></app-portal-video-with-description>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalPromotedInfoBlockList">
                  <app-portal-promoted-info [data]="block.angularBlockListData"></app-portal-promoted-info>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalEventsBlockList">
                  <app-portal-event [data]="block.angularBlockListData"></app-portal-event>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalSupportInfoBlockList">
                  <app-portal-support-info [data]="block.angularBlockListData"></app-portal-support-info>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalCareerPromotedContentBlockList">
                  <app-portal-career-promoted-content [data]="block.angularBlockListData"></app-portal-career-promoted-content>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalOrganizationalServicesBlockList">
                  <app-portal-organizational-services [data]="block.angularBlockListData"></app-portal-organizational-services>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalContentFooterBlockList">
                  <app-portal-content-footer [data]="block.angularBlockListData"></app-portal-content-footer>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.EventsBlockBlockList">
                  <app-event-block [data]="block.angularBlockListData"></app-event-block>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.MessageBlockList">
                  <app-message-block [data]="block.angularBlockListData"></app-message-block>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalLinksBlockList">
                  <app-portal-links [data]="block.angularBlockListData"></app-portal-links>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalQuestionAndAnswerBlockList">
                  <app-portal-questions-and-answers [data]="block.angularBlockListData.result"></app-portal-questions-and-answers>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.AdditionalLinksBlockList">
                  <app-additional-links-block-list [data]="block.angularBlockListData"></app-additional-links-block-list>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.PortalAngularBillingInfo">
                  <app-billing-table [data]="block.angularBlockListData"></app-billing-table>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentCoursesAndScheduleBlockList">
                  <app-schedule-page [pageData]="block.angularBlockListData"></app-schedule-page>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.StudentAllCoursesBlockList">
                  <app-courses-card [pageData]="block.angularBlockListData"></app-courses-card>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.CareerLatestJobs">
                  <app-career-latest-jobs [pageData]="block.angularBlockListData"></app-career-latest-jobs>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.SuccessStoriesCubesAngularBlockList">
                  <app-success-stories-cubes [blockData]="block.angularBlockListData"></app-success-stories-cubes>
                </ng-container>
                <ng-container *ngSwitchCase="angularBlockListType.CollaborationsAngularBlockList">
                  <app-collaborations [blockData]="block.angularBlockListData"></app-collaborations>
                </ng-container>
              </div>

              <div *ngSwitchCase="blockListType.PersonalBlockList">
                <!-- Handle PersonalBlockList type -->
                <p>Personal Block List</p>
              </div>
              
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <input type="hidden" id="currentNodeId" [value]="pageData.pageNodeId" />
</div>
